// 引入全局css样式
import '@/styles/index.scss'
import './style.css'

import { createApp } from 'vue'
import App from './App.vue'

import i18n from './i18n'

// 引入路由
import router from './router'
import { createPinia } from 'pinia'
import { setPinia } from '@/api/request'

const app = createApp(App)
const pinia = createPinia()

// 设置 pinia 实例供 request.js 使用
setPinia(pinia)

app.use(router)
app.use(pinia)
app.use(i18n)

// 动态设置 Open Graph meta 标签
const updateOpenGraph = () => {
  const currentUrl = window.location.href
  const ogImageUrl = `${window.location.origin}/favicon.png`

  // 设置 og:url 和 twitter:url（需要动态获取当前页面 URL）
  const ogUrl = document.getElementById('og-url')
  const twitterUrl = document.getElementById('twitter-url')
  if (ogUrl) ogUrl.setAttribute('content', currentUrl)
  if (twitterUrl) twitterUrl.setAttribute('content', currentUrl)

  // 设置 og:image 和 twitter:image
  const ogImage = document.getElementById('og-image')
  const twitterImage = document.getElementById('twitter-image')
  if (ogImage) ogImage.setAttribute('content', ogImageUrl)
  if (twitterImage) twitterImage.setAttribute('content', ogImageUrl)

  // console.log('Open Graph updated:', { currentUrl, ogImageUrl })
}

// 在页面加载时更新
updateOpenGraph()

// 监听路由变化
if (window.history.pushState) {
  window.addEventListener('popstate', updateOpenGraph)
}

app.mount('#app')
